/* tslint:disable */
/* eslint-disable */
/**
 * B2B Air Booking
 * Endpoints needed to complete air booking  # Tracking Metrics * `b2bportal.availability.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.prediction.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.prediction.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.availability.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.availability.volume`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.booking.product.error`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.quote.product.error`   * tags: `api_version`, `error_code`, `product`, `quote_action`, `tenantid`   # Tracking Error Codes * `application_error` * `bad_request` * `check_in_minimum_age_not_met` * `duplicate_booking` * `duplicated_national_id` * `duplicated_passport` * `excessive_activity` * `expired_national_id` * `expired_passport` * `expiring_national_id` * `expiring_passport` * `extra_bags_error` * `illegal_lap_infant_ktn` * `illegal_lap_infant_redress` * `inactivity` * `ineligible` * `internal_error` * `invalid_customer` * `invalid_passenger_name` * `invalid_passengers` * `invalid_passport_number` * `invalid_passport_or_national_id_number` * `lap_infant_too_old` * `lap_infants_unsupported` * `malformed_known_traveler_number` * `malformed_redress_number` * `missing_airline_locator` * `missing_national_id` * `missing_nationality` * `missing_passport_number` * `missing_passport_or_national_id` * `missing_passport` * `no_adult_passenger` * `no_availability` * `no_contact_information` * `no_ticketless_response` * `passenger_name_too_short` * `passenger_not_found` * `passthrough_payment_error` * `provider_error` * `request_canceled` * `request_deserialization_error` * `response_serialization_error` * `restricted_city` * `restricted_country` * `seated_infants_unsupported` * `session_closed` * `shop_async_error` * `ticketing_not_started` * `ticketing_unconfirmed` * `ticketing_unknown` * `too_many_lap_infants` * `too_many_passengers` * `transient_service_error` * `unexpected_passengers` * `unknown_sabre_app_error` * `unknown` * `unsupported_name_characters` * `unsupported_payment_kind` * `upgrade_required` * `user_not_found`
 *
 * The version of the OpenAPI document: v9p193
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AcceptScheduleChangeRequest {
    'itineraryId': string;
}
export interface AcceptScheduleChangeResponse {
    'success': boolean;
    'itinerary': string;
    'errorCodes'?: Array<string>;
}
export interface AccountPrice {
    'currency': string;
    'value': number;
    'currencyDescription'?: string;
}
export interface AdditionalInfo {
    'sessionId'?: string;
}
export interface AdultWithLapInfant {
    'adult': AssociatedPassenger;
    'infant': AssociatedPassenger;
}
export interface AgentLocator {
    'provider': AgentLocatorProvider;
    'value': string;
    'unscopedValue': string;
}


export const AgentLocatorProvider = {
    ach: 'ach',
    amadeus: 'amadeus',
    apollo: 'apollo',
    consolid: 'consolid',
    ctw: 'ctw',
    datalex: 'datalex',
    facade: 'facade',
    farelogix: 'farelogix',
    farelogixNdc: 'farelogixNdc',
    fr24: 'fr24',
    galileo: 'galileo',
    gdx: 'gdx',
    letsflyFaremarket: 'letsflyFaremarket',
    letsflyTechhub: 'letsflyTechhub',
    multiProvider: 'multiProvider',
    navitaireNdc: 'navitaireNdc',
    sabre: 'sabre',
    travelfusion: 'travelfusion',
    unififi: 'unififi'
} as const;

export type AgentLocatorProvider = typeof AgentLocatorProvider[keyof typeof AgentLocatorProvider];


export interface Airline {
    'displayName': string;
    'customHashTag'?: string;
    'fullName': string;
    'isLcc': boolean;
    'webLinks': WebLinks;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof Airline
     */
    'code': string;
    'cabinClassMappings': { [key: string]: HopperCabinClass; };
    'phone'?: string;
}
/**
 * `cityName` - The name of the metropolitan area generally associated with the airport
   e.g. the YUL airport is in Dorval but should have cityName == "Montreal"
   e.g. the EWL airport serves New York City but it's still treated as belonging to Newark, so cityName == "Newark"
 * `servedCity` - IATA has a concept of "served metropolitan area";
   e.g. Newark Intl Airport (EWR) is geographically in Newark but "serves" NYC
   This is a good presumed destination (for example for hotels or whatever)
   It is not however an acceptable display name for the airport (So we should not display EWR as "New York (EWR)")
 * `military` - military airports often place restrictions on international travelers
 * @export
 * @interface Airport
 */
export interface Airport {
    'coordinates': Coordinates;
    'servedCityName': string;
    'name': string;
    /**
     * The name of the metropolitan area generally associated with the airport
   e.g. the YUL airport is in Dorval but should have cityName == "Montreal"
   e.g. the EWL airport serves New York City but it's still treated as belonging to Newark, so cityName == "Newark"
     * @type {string}
     * @memberof Airport
     */
    'cityName': string;
    /**
     * 3 character IATA city code
     * @type {string}
     * @memberof Airport
     */
    'servedCity': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Airport
     */
    'code': string;
    'geography': GeopoliticalInfo;
    /**
     * military airports often place restrictions on international travelers
     * @type {boolean}
     * @memberof Airport
     */
    'military': boolean;
}
export interface Alias {
    'value': string;
}
/**
 * Model describing the ordered extra bags for a booking, not broken down per passenger
 * @export
 * @interface AllPassengerExtraBags
 */
export interface AllPassengerExtraBags {
    'bags': ExtraBags;
    'OrderedExtraBags': OrderedExtraBagsEnum;
}


export interface AlreadyDone {
    'Reason': ReasonEnum;
}


/**
 * the contract has already been exercised, so there are no remaining exercise options
 * @export
 * @interface AlreadyExercised
 */
export interface AlreadyExercised {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


export interface AmadeusBrand {
    'brandId': string;
    'brandName'?: string;
}
/**
 * A monetary amount
 * @export
 * @interface Amount
 */
export interface Amount {
    'amount': number;
    'currency': string;
}
/**
 * the contract is eligible to be redeemed through any exercise type
 * @export
 * @interface AnyExerciseEligible
 */
export interface AnyExerciseEligible {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


/**
 * @type AnyResponse
 * @export
 */
export type AnyResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & AnySuccess;

export const AnyResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type AnyResponseEnum = typeof AnyResponseEnum[keyof typeof AnyResponseEnum];


export interface AnySuccess {
    'value': any;
    'Response': AnyResponseEnum;
}


export const Assistance = {
    BLND: 'BLND',
    DEAF: 'DEAF',
    STCR: 'STCR',
    WCBD: 'WCBD',
    WCBW: 'WCBW',
    WCHC: 'WCHC',
    WCHR: 'WCHR',
    WCHS: 'WCHS',
    WCLB: 'WCLB',
    WCMP: 'WCMP',
    WCOB: 'WCOB'
} as const;

export type Assistance = typeof Assistance[keyof typeof Assistance];


export interface AssociatedContact {
    'nameNumber': string;
    'contact': Contact;
}
export interface AssociatedPassenger {
    'nameNumber': string;
    'type': string;
    'person': Person;
}
/**
 * @type Availability
 * @export
 */
export type Availability = { Availability: 'Available' } & Available | { Availability: 'AvailableAfter' } & AvailableAfter | { Availability: 'AvailableUntil' } & AvailableUntil | { Availability: 'Unavailable' } & Unavailable;

export const AvailabilityEnum = {
    Available: 'Available',
    AvailableAfter: 'AvailableAfter',
    AvailableUntil: 'AvailableUntil',
    Unavailable: 'Unavailable'
} as const;

export type AvailabilityEnum = typeof AvailabilityEnum[keyof typeof AvailabilityEnum];


export interface Available {
    'Availability': AvailabilityEnum;
}


export interface AvailableAfter {
    'time': number;
    'Availability': AvailabilityEnum;
}


export interface AvailableUntil {
    'time': number;
    'Availability': AvailabilityEnum;
}


export interface BaggageAllowance {
    'pieces': number;
    'descriptions': Array<string>;
    'maximumMass'?: Mass;
}
export interface BaggageCharge {
    'firstPiece': number;
    'amount': number;
    'maximumMass'?: Mass;
    'lastPiece': number;
    'currency': string;
    'descriptions': Array<string>;
}
/**
 * @type BaggageInfo
 * @export
 */
export type BaggageInfo = { BaggageInfo: 'Allowed' } & BaggageInfoAllowed | { BaggageInfo: 'NotAllowed' } & BaggageInfoNotAllowed | { BaggageInfo: 'Unknown' } & BaggageInfoUnknown;

export interface BaggageInfoAllowed {
    'allowance': BaggageAllowance;
    'charges': Array<BaggageCharge>;
    'BaggageInfo': BaggageInfoEnum;
}


export const BaggageInfoEnum = {
    Allowed: 'Allowed',
    NotAllowed: 'NotAllowed',
    Unknown: 'Unknown'
} as const;

export type BaggageInfoEnum = typeof BaggageInfoEnum[keyof typeof BaggageInfoEnum];


export interface BaggageInfoNotAllowed {
    'BaggageInfo': BaggageInfoEnum;
}


export interface BaggageInfoUnknown {
    'BaggageInfo': BaggageInfoEnum;
}


/**
 * Describes the allowed mass/weight of a baggage item
 * @export
 * @interface BaggageMass
 */
export interface BaggageMass {
    'value': number;
    'unit': string;
}
export interface BookedFlightItinerary {
    'source'?: ItinerarySource;
    'travelItinerary': TravelItinerary;
    'isHopperMor'?: boolean;
    'chfarTrackingProperties'?: TrackingProperties;
    'sellingPricing': TripPricingSummary;
    'paymentAmountInfo'?: PaymentsAndCredits;
    'freeCancellation': Availability;
    'passengers': SeatedPassengers;
    'transactionStoreId'?: ID;
    'restrictions'?: Restrictions;
    'totalPayment': PaymentAmount;
    'faresRules': FareRules;
    'payment'?: LegacyPayment;
    'priceDropEligibility': PriceDropProtection;
    'id': string;
    'multiTicketType': MultiTicketType;
    'paymentBreakdown'?: PaymentBreakdown;
    'additionalInfo'?: AdditionalInfo;
    'scheduleChange'?: ScheduleChange;
    'baggage'?: ItineraryBaggage;
    'seats'?: ItinerarySeats;
    'tripAncillaries': TripAncillaryIds;
}


/**
 * `chfar` - Information relevant to ChFAR (Change for Any Reason) for any post-booking needs
 * `cfar` - Information relevant to CFAR (Cancel for Any Reason) for any post-booking needs
 * `travelCreditCopy` - Displayable description for `travelCredit`.
 * `portalType` - Used by the capone-corporate portal, whose My Trips page shows trips from capone consumer
 * @export
 * @interface BookedFlightItineraryWithDepartureTime
 */
export interface BookedFlightItineraryWithDepartureTime {
    'departureTime'?: string;
    'travelCredit'?: TravelCredit;
    'disruptionProtectionRebook': DisruptionProtectionRebook;
    'chfar'?: ChfarContract;
    'emailAddress'?: string;
    'ancillaries': TripAncillaryContracts;
    'hoursToDeparture'?: number;
    'bookedItinerary': BookedFlightItinerary;
    'cfar'?: CfarContract;
    'rawStatus': Status;
    'status': PortalItineraryStatus;
    /**
     * Displayable description for `travelCredit`.
     * @type {string}
     * @memberof BookedFlightItineraryWithDepartureTime
     */
    'travelCreditCopy'?: string;
    /**
     * Used by the capone-corporate portal, whose My Trips page shows trips from capone consumer
     * @type {string}
     * @memberof BookedFlightItineraryWithDepartureTime
     */
    'portalType'?: string;
}


/**
 * deprecated
 * @export
 * @interface Cancel
 */
export interface Cancel {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


export interface CancelOrChangeId {
    'productId': string;
    'policyId': string;
    'ProtectionPolicyId'?: ProtectionPolicyIdEnum;
    'ProtectionId'?: ProtectionIdEnum;
}


export interface Cancellations {
    'EventCovered': EventCoveredEnum;
}


/**
 * `isExercisable` - Is the cfar contract exercisable
 * @export
 * @interface Cfar
 */
export interface Cfar {
    'expired': string;
    'policyData'?: CfarOfferPolicyData;
    'voidExtension'?: VoidExtension;
    'id': CfarId;
    /**
     * Is the cfar contract exercisable
     * @type {boolean}
     * @memberof Cfar
     */
    'isExercisable': boolean;
    'created': string;
}
/**
 * `premium` - Total cost of CFAR premium
 * `isExercisable` - False if CFAR is no longer on the itinerary. It can happen if user requests to remove CFAR and get a premium refund.
 * @export
 * @interface CfarContract
 */
export interface CfarContract {
    'premium': Prices;
    /**
     * False if CFAR is no longer on the itinerary. It can happen if user requests to remove CFAR and get a premium refund.
     * @type {boolean}
     * @memberof CfarContract
     */
    'isExercisable': boolean;
}
/**
 * `quoteId` - the quote id of the cfar offer if it was created with cfar-core
 * @export
 * @interface CfarId
 */
export interface CfarId {
    'ProtectionPolicyId'?: ProtectionPolicyIdEnum;
    'policyId': string;
    'productId': string;
    'ProtectionId'?: ProtectionIdEnum;
    /**
     * the quote id of the cfar offer if it was created with cfar-core
     * @type {string}
     * @memberof CfarId
     */
    'quoteId'?: string;
}


export interface CfarOfferPolicyData {
    'premiumPercentage'?: number;
    'cashCoveragePercentage': number;
    'offerType': string;
}
/**
 * `isExercisable` - Is the user able to exercise chfar.
 * @export
 * @interface Chfar
 */
export interface Chfar {
    'expired': string;
    'voidExtension'?: ChfarVoidExtension;
    'id': ChfarId;
    /**
     * Is the user able to exercise chfar.
     * @type {boolean}
     * @memberof Chfar
     */
    'isExercisable': boolean;
    'created': string;
}
/**
 * `coverage` - Total original coverage of ChFAR
 * `premium` - Total cost of ChFAR premium
 * `isExercisable` - False if ChFAR is no longer on the itinerary. It can happen if user requests to remove ChFAR and get a premium refund.
 * @export
 * @interface ChfarContract
 */
export interface ChfarContract {
    'coverage': Prices;
    'contractId': string;
    'premium': Prices;
    /**
     * False if ChFAR is no longer on the itinerary. It can happen if user requests to remove ChFAR and get a premium refund.
     * @type {boolean}
     * @memberof ChfarContract
     */
    'isExercisable': boolean;
    'expiration': string;
}
export interface ChfarCredit {
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
    'AncillaryCredit': PaymentLineItemAncillaryCreditEnum;
}


/**
 * When present, indicates a chfar contract is being exercised for this booking.
 * @export
 * @interface ChfarExercise
 */
export interface ChfarExercise {
    'contractId': string;
}
export interface ChfarId {
    'productId': string;
    'policyId': string;
    'ProtectionPolicyId'?: ProtectionPolicyIdEnum;
    'ProtectionId'?: ProtectionIdEnum;
}


export interface ChfarVoidExtension {
    'days': number;
    'at': string;
}
/**
 * deprecated
 * @export
 * @interface Conclude
 */
export interface Conclude {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


export interface Contact {
    'phoneNumber': string;
    'emailAddress': string;
    'givenName'?: string;
    'surname'?: string;
}
export interface ContactAirline {
    'Reason': ReasonEnum;
}


export interface ContactSupport {
    'Reason': ReasonEnum;
}


export interface Coordinates {
    'lat': number;
    'lon': number;
}
/**
 * @type Credit
 * Deprecated.
 * @export
 */
export type Credit = { Credit: 'ChfarExerciseCredit' } & CreditChfarExerciseCredit | { Credit: 'DisruptionProtectionCredit' } & CreditDisruptionProtectionCredit | { Credit: 'PriceFreezeExerciseCredit' } & CreditPriceFreezeExerciseCredit;

export interface CreditCard {
    'updatedAt'?: string;
    'zip': string;
    'tag': LegacyPaymentEnum;
    'year': number;
    'numberDisplay': string;
    'country': string;
    'alias'?: Alias;
    'lastName': string;
    'firstName': string;
    'id': string;
    'last4'?: string;
    'token': string;
    'createdAt': string;
    'bin'?: string;
    'cardType': string;
    'scanned': ScanResult;
    'month': number;
}


export interface CreditChfarExerciseCredit {
    'amount': FiatAmount;
    'Credit': CreditEnum;
}


export interface CreditDisruptionProtectionCredit {
    'amount': FiatAmount;
    'Credit': CreditEnum;
}


export const CreditEnum = {
    ChfarExerciseCredit: 'ChfarExerciseCredit',
    DisruptionProtectionCredit: 'DisruptionProtectionCredit',
    PriceFreezeExerciseCredit: 'PriceFreezeExerciseCredit'
} as const;

export type CreditEnum = typeof CreditEnum[keyof typeof CreditEnum];


export interface CreditPriceFreezeExerciseCredit {
    'amount': FiatAmount;
    'Credit': CreditEnum;
}


/**
 * Deprecated. Use `payments` field on `quoteBreakdown` instead.
 * @export
 * @interface CreditSummary
 */
export interface CreditSummary {
    'totalCredits': TripCredits;
    'creditsByPerson': Array<PersonCredits>;
}
/**
 * `paxCount` - contract.premium.paxCount
 * `postBookingPaymentId` - if it is a post booking purchase, can include the payment from contract.paymentContext
 * @export
 * @interface Delay
 */
export interface Delay {
    /**
     * contract.premium.paxCount
     * @type {number}
     * @memberof Delay
     */
    'paxCount'?: number;
    /**
     * if it is a post booking purchase, can include the payment from contract.paymentContext
     * @type {string}
     * @memberof Delay
     */
    'postBookingPaymentId'?: string;
    'id': DelayId;
    'status': DisruptionContractStatus;
    'policyDetails'?: DelayPolicyDetails;
    'created': string;
}
/**
 * `quoteId` - tenant specific: capone. The quote id from disruption-offers. To be removed after the capital one cart migration
 * @export
 * @interface DelayId
 */
export interface DelayId {
    'ProtectionPolicyId'?: ProtectionPolicyIdEnum;
    'policyId': string;
    'productId': string;
    'ProtectionId'?: ProtectionIdEnum;
    /**
     * tenant specific: capone. The quote id from disruption-offers. To be removed after the capital one cart migration
     * @type {string}
     * @memberof DelayId
     */
    'quoteId'?: string;
}


export interface DelayPolicyDetails {
    'premium': Amount;
    'coverage'?: Amount;
    'minimumDelay': MinimumDelay;
}
export interface Delays {
    'EventCovered': EventCoveredEnum;
}


export interface DeletePassengerRequest {
    'personId': string;
}
export interface DenyScheduleChangeRequest {
    'itineraryId': string;
    'outboundPreferences': Array<ScheduleChangeChoice>;
    'returnPreferences': Array<ScheduleChangeChoice>;
    'additionalRemarks'?: string;
}
export interface DenyScheduleChangeResponse {
    'success': boolean;
    'itinerary': string;
    'errorCodes'?: Array<string>;
}
/**
 * @type DisruptionContractStatus
 * the status of the attached policy
 * @export
 */
export type DisruptionContractStatus = { DisruptionContractStatus: 'AlreadyExercised' } & AlreadyExercised | { DisruptionContractStatus: 'AnyExerciseEligible' } & AnyExerciseEligible | { DisruptionContractStatus: 'Cancel' } & Cancel | { DisruptionContractStatus: 'Conclude' } & Conclude | { DisruptionContractStatus: 'Eligible' } & Eligible | { DisruptionContractStatus: 'ExerciseNotEligible' } & ExerciseNotEligible | { DisruptionContractStatus: 'MarkedEligible' } & MarkedEligible | { DisruptionContractStatus: 'Purchase' } & Purchase | { DisruptionContractStatus: 'Rebook' } & Rebook | { DisruptionContractStatus: 'RebookOnlyEligible' } & RebookOnlyEligible | { DisruptionContractStatus: 'Redeem' } & Redeem | { DisruptionContractStatus: 'Refund' } & Refund | { DisruptionContractStatus: 'Remove' } & Remove;

export const DisruptionContractStatusEnum = {
    AlreadyExercised: 'AlreadyExercised',
    AnyExerciseEligible: 'AnyExerciseEligible',
    Cancel: 'Cancel',
    Conclude: 'Conclude',
    Eligible: 'Eligible',
    ExerciseNotEligible: 'ExerciseNotEligible',
    MarkedEligible: 'MarkedEligible',
    Purchase: 'Purchase',
    Rebook: 'Rebook',
    RebookOnlyEligible: 'RebookOnlyEligible',
    Redeem: 'Redeem',
    Refund: 'Refund',
    Remove: 'Remove'
} as const;

export type DisruptionContractStatusEnum = typeof DisruptionContractStatusEnum[keyof typeof DisruptionContractStatusEnum];


/**
 * This field is specified to indicate the request is for exercising a purchased Disruption Protection product and rebooking a disrupted flight. For a normal booking, this field should be set to None
 * @export
 * @interface DisruptionProtection
 */
export interface DisruptionProtection {
    'originalItineraryId': string;
}
export interface DisruptionProtectionAncillaryContract {
    'id': string;
    'status': DisruptionContractStatus;
    'policyDetails'?: DisruptionProtectionDisruptionProtectionPolicyDetails;
}
export interface DisruptionProtectionCredit {
    'originalItineraryId': string;
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
    'AncillaryCredit': PaymentLineItemAncillaryCreditEnum;
}


/**
 * `rebookingLimit` - maximum amount for rebooking
 * `delayThreshold` - delay threshold represented as number of minutes
 * `policyStatus` - the status of the attached policy
 * `policyExpiration` - policy expiration time
 * `containsCreditReimbursementRedemptionPolicy` - returns true if redemption policy contains credit reimbursement
 * `eventsCovered` - events covered by the policy
 * @export
 * @interface DisruptionProtectionDisruptionProtectionPolicyDetails
 */
export interface DisruptionProtectionDisruptionProtectionPolicyDetails {
    'rebookingLimit'?: Prices;
    /**
     * delay threshold represented as number of minutes
     * @type {number}
     * @memberof DisruptionProtectionDisruptionProtectionPolicyDetails
     */
    'delayThreshold'?: number;
    'policyStatus': DisruptionContractStatus;
    /**
     * policy expiration time
     * @type {string}
     * @memberof DisruptionProtectionDisruptionProtectionPolicyDetails
     */
    'policyExpiration'?: string;
    /**
     * returns true if redemption policy contains credit reimbursement
     * @type {boolean}
     * @memberof DisruptionProtectionDisruptionProtectionPolicyDetails
     */
    'containsCreditReimbursementRedemptionPolicy'?: boolean;
    /**
     * events covered by the policy
     * @type {Array<EventCovered>}
     * @memberof DisruptionProtectionDisruptionProtectionPolicyDetails
     */
    'eventsCovered': Array<EventCovered>;
}
/**
 * @type DisruptionProtectionRebook
 * @export
 */
export type DisruptionProtectionRebook = { DisruptionProtectionRebook: 'IsRebook' } & IsRebook | { DisruptionProtectionRebook: 'NotRebook' } & NotRebook;

export const DisruptionProtectionRebookEnum = {
    IsRebook: 'IsRebook',
    NotRebook: 'NotRebook'
} as const;

export type DisruptionProtectionRebookEnum = typeof DisruptionProtectionRebookEnum[keyof typeof DisruptionProtectionRebookEnum];


export interface DriverLicense {
    /**
     * 2 character country code
     * @type {string}
     * @memberof DriverLicense
     */
    'country': string;
    'cityCode': string;
    'street': string;
    'postCode': string;
}
/**
 * deprecated
 * @export
 * @interface Eligible
 */
export interface Eligible {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


export interface Email {
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof Email
     */
    'email': string;
    'MessageMethod'?: MessageMethodEnum;
}


export interface ErrorCode {
    'code': string;
    'details'?: string;
    'trackingCode'?: string;
}
/**
 * @type EventCovered
 * @export
 */
export type EventCovered = { EventCovered: 'Cancellations' } & Cancellations | { EventCovered: 'Delays' } & Delays | { EventCovered: 'MissedConnections' } & MissedConnections;

export const EventCoveredEnum = {
    Cancellations: 'Cancellations',
    Delays: 'Delays',
    MissedConnections: 'MissedConnections'
} as const;

export type EventCoveredEnum = typeof EventCoveredEnum[keyof typeof EventCoveredEnum];


/**
 * the contract is NOT eligible for any redemption
 * @export
 * @interface ExerciseNotEligible
 */
export interface ExerciseNotEligible {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


/**
 * Represents a quoted/ordered extra bag
 * @export
 * @interface ExtraBag
 */
export interface ExtraBag {
    'baggageNumber': number;
    'price': Prices;
    'descriptions': Array<string>;
    'maximumMass'?: BaggageMass;
}
export interface ExtraBaggageOptions {
    'carryOnBag'?: BaggageInfo;
    'checkedBag'?: BaggageInfo;
    'personalItem'?: BaggageInfo;
}
export interface ExtraBags {
    'checkedBags': Array<ExtraBag>;
    'carryOnBags': Array<ExtraBag>;
    'personalItems': Array<ExtraBag>;
}
export interface Failure {
    'errors': Array<ErrorCode>;
    'Response': FlightItineraryResponseResponseEnum;
}


export interface FareBrand {
    'gdxFareBrand'?: GdxBrand;
    'amadeusFareBrand'?: AmadeusBrand;
    'navitaireNdcBrand'?: NavitaireNdcBrand;
    'travelportFareBrand'?: TravelportBrand;
    'sabreFareBrand'?: SabreBrand;
    'travelFusionFareBrand'?: TravelFusionBrand;
}
export interface FareRule {
    'title': string;
    'text': string;
}
export interface FareRuleIndex {
    'fareBasisCode': string;
    'segment': number;
}
export interface FareRules {
    'rules': Array<ItineraryFareRules>;
}
export interface FiatAmount {
    'currency': string;
    'amount': number;
    'PaymentAmount'?: PaymentAmountEnum;
}


/**
 * A cash amount
 * @export
 * @interface FiatPrice
 */
export interface FiatPrice {
    'currencyCode': string;
    'currencySymbol': string;
    'value': number;
}
export interface FixedPolicyDetails {
    'premium': Amount;
    'coverage': Amount;
    'PolicyDetails': PolicyDetailsEnum;
}


/**
 * Deprecated. Use `payments` field on `quoteBreakdown` instead.
 * @export
 * @interface FlightCreditSummary
 */
export interface FlightCreditSummary {
    'pricingBeforeCredits': TripPricingSummary;
    'credits': CreditSummary;
}
export const FlightError = {
    CheckInMinimumAgeNotMet: 'CheckInMinimumAgeNotMet',
    DuplicateBooking: 'DuplicateBooking',
    DuplicatedNationalId: 'DuplicatedNationalId',
    DuplicatedPassport: 'DuplicatedPassport',
    ExcessiveActivity: 'ExcessiveActivity',
    ExpiredNationalId: 'ExpiredNationalId',
    ExpiredPassport: 'ExpiredPassport',
    ExpiringNationalId: 'ExpiringNationalId',
    ExpiringPassport: 'ExpiringPassport',
    ExtraBagsError: 'ExtraBagsError',
    IllegalLapInfantKTN: 'IllegalLapInfantKTN',
    IllegalLapInfantRedress: 'IllegalLapInfantRedress',
    Inactivity: 'Inactivity',
    InvalidCustomer: 'InvalidCustomer',
    InvalidPassengerName: 'InvalidPassengerName',
    InvalidPassengers: 'InvalidPassengers',
    InvalidPassportNumber: 'InvalidPassportNumber',
    InvalidPassportOrNationalIdNumber: 'InvalidPassportOrNationalIdNumber',
    LapInfantTooOld: 'LapInfantTooOld',
    LapInfantsUnsupported: 'LapInfantsUnsupported',
    MalformedKnownTravelerNumber: 'MalformedKnownTravelerNumber',
    MalformedRedressNumber: 'MalformedRedressNumber',
    MissingAirlineLocator: 'MissingAirlineLocator',
    MissingNationalId: 'MissingNationalId',
    MissingNationality: 'MissingNationality',
    MissingPassport: 'MissingPassport',
    MissingPassportNumber: 'MissingPassportNumber',
    MissingPassportOrNationalId: 'MissingPassportOrNationalId',
    NoAdultPassenger: 'NoAdultPassenger',
    NoAvailability: 'NoAvailability',
    NoContactInformation: 'NoContactInformation',
    NoTicketlessResponse: 'NoTicketlessResponse',
    PassengerNameTooShort: 'PassengerNameTooShort',
    PassengerNotFound: 'PassengerNotFound',
    PassthroughPaymentError: 'PassthroughPaymentError',
    ProviderError: 'ProviderError',
    SeatedInfantsUnsupported: 'SeatedInfantsUnsupported',
    SessionClosed: 'SessionClosed',
    ShopAsyncError: 'ShopAsyncError',
    TicketingNotStarted: 'TicketingNotStarted',
    TicketingUnconfirmed: 'TicketingUnconfirmed',
    TicketingUnknown: 'TicketingUnknown',
    TooManyLapInfants: 'TooManyLapInfants',
    TooManyPassengers: 'TooManyPassengers',
    TransientServiceError: 'TransientServiceError',
    UnexpectedPassengers: 'UnexpectedPassengers',
    Unknown: 'Unknown',
    UnknownSabreAppError: 'UnknownSabreAppError',
    UnsupportedNameCharacters: 'UnsupportedNameCharacters',
    UnsupportedPaymentKind: 'UnsupportedPaymentKind',
    UpgradeRequired: 'UpgradeRequired'
} as const;

export type FlightError = typeof FlightError[keyof typeof FlightError];


export interface FlightItineraryRequest {
    'states': Array<FlightItineraryState>;
    'referenceDateTime': string;
}
export interface FlightItineraryResponse {
    'itineraries': { [key: string]: Array<BookedFlightItineraryWithDepartureTime>; };
    'airports': { [key: string]: Airport; };
    'airlines': { [key: string]: Airline; };
    'context': TripContext;
}
/**
 * @type FlightItineraryResponseResponse
 * @export
 */
export type FlightItineraryResponseResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & FlightItineraryResponseSuccess;

export const FlightItineraryResponseResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type FlightItineraryResponseResponseEnum = typeof FlightItineraryResponseResponseEnum[keyof typeof FlightItineraryResponseResponseEnum];


export interface FlightItineraryResponseSuccess {
    'value': FlightItineraryResponse;
    'Response': FlightItineraryResponseResponseEnum;
}


/**
 * `ticketIndex` - Indicates which ticket the segment is associated to.
 * `codeSharedCarrier` - Additional text about codeshare or marketing arrangement, e.g. 'Republic Airways As American Eagle.'
 * `isSelfTransferLayover` - To know if the next segment is from another ticket and the user has to re-check-in. Computed when we know all the other segments in the slice.
 * @export
 * @interface FlightItinerarySegment
 */
export interface FlightItinerarySegment {
    'zonedUpdatedArrival'?: string;
    'scheduledArrival': string;
    /**
     * Indicates which ticket the segment is associated to.
     * @type {number}
     * @memberof FlightItinerarySegment
     */
    'ticketIndex'?: number;
    'plusDays': number;
    'updatedArrival'?: string;
    'marketingAirline': SegmentAirlineInfo;
    'zonedUpdatedDeparture'?: string;
    'updatedDeparture'?: string;
    'fareBrand'?: FareBrand;
    'scheduledDeparture': string;
    'equipmentType'?: string;
    'zonedScheduledArrival'?: string;
    'stopoverDurationMinutes'?: number;
    'origin': Location;
    'status': FlightItinerarySegmentStatus;
    'originTimeZone'?: string;
    'segmentNumber': number;
    'bookingClassCode': string;
    'zonedScheduledDeparture'?: string;
    /**
     * Additional text about codeshare or marketing arrangement, e.g. 'Republic Airways As American Eagle.'
     * @type {string}
     * @memberof FlightItinerarySegment
     */
    'codeSharedCarrier'?: string;
    'operatingAirline'?: SegmentAirlineInfo;
    /**
     * To know if the next segment is from another ticket and the user has to re-check-in. Computed when we know all the other segments in the slice.
     * @type {boolean}
     * @memberof FlightItinerarySegment
     */
    'isSelfTransferLayover': boolean;
    'destinationTimeZone'?: string;
    'destination': Location;
    'cabinClassName'?: string;
    'stops': number;
}


export const FlightItinerarySegmentStatus = {
    Canceled: 'Canceled',
    Confirmed: 'Confirmed',
    ConfirmedPendingNewChange: 'ConfirmedPendingNewChange',
    Declined: 'Declined',
    Pending: 'Pending',
    UnMapped: 'UnMapped',
    UnMappedPersisted: 'UnMappedPersisted'
} as const;

export type FlightItinerarySegmentStatus = typeof FlightItinerarySegmentStatus[keyof typeof FlightItinerarySegmentStatus];


export interface FlightItinerarySlice {
    'segments': Array<FlightItinerarySegment>;
    'restrictions'?: Restrictions;
    'fareShelf'?: SegmentShelf;
}
export const FlightItineraryState = {
    Canceled: 'Canceled',
    Future: 'Future',
    Invalid: 'Invalid',
    Past: 'Past',
    Present: 'Present'
} as const;

export type FlightItineraryState = typeof FlightItineraryState[keyof typeof FlightItineraryState];


export interface FrequentFlyerNumber {
    'value': string;
}
export interface GdxBrand {
    'brandId': string;
    'brandName'?: string;
}
/**
 * 

* `F` - Female
* `M` - Male
 * @export
 * @enum {string}
 */

export const Gender = {
    F: 'F',
    M: 'M'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];


export interface GeopoliticalInfo {
    /**
     * 2 character country code
     * @type {string}
     * @memberof GeopoliticalInfo
     */
    'countryCode': string;
    'regionCode'?: string;
    'currency': string;
    'timeZone': string;
}
export interface GetPassengerRequest {
    'personId': string;
}
export const HopperCabinClass = {
    Business: 'Business',
    Economy: 'Economy',
    First: 'First',
    PremiumEconomy: 'PremiumEconomy',
    Unknown: 'Unknown'
} as const;

export type HopperCabinClass = typeof HopperCabinClass[keyof typeof HopperCabinClass];


export interface HotelLoyaltyNumber {
    'value': string;
}
/**
 * @type ID
 * @export
 */
export type ID = { ID: 'PaymentFulfillmentService' } & PaymentFulfillmentService | { ID: 'PaymentMachine' } & PaymentMachine;

export const IDEnum = {
    PaymentFulfillmentService: 'PaymentFulfillmentService',
    PaymentMachine: 'PaymentMachine'
} as const;

export type IDEnum = typeof IDEnum[keyof typeof IDEnum];


export interface InfantNotIssued {
    'TicketNumberType': TicketNumberTypeEnum;
}


/**
 * `finePrintUrl` - The URL to the policy fine print detailing the coverage and exercise procedures.
 * @export
 * @interface Insurance
 */
export interface Insurance {
    'id': string;
    /**
     * The URL to the policy fine print detailing the coverage and exercise procedures.
     * @type {string}
     * @memberof Insurance
     */
    'finePrintUrl': string;
}
export interface InsuranceId {
    'productId': string;
    'ProtectionId'?: ProtectionIdEnum;
}


export interface InvalidPassengers {
    'warnings': Array<PassengerWarning>;
    'errors': Array<PassengerError>;
    'PassengersResponse': PassengersResponseEnum;
}


export interface IsEligible {
    'candidateId': string;
    'PriceDropProtection': PriceDropProtectionEnum;
    'trackingPropertiesV2': TrackingProperties;
    'maximumRefund': PriceDropMaximumRefund;
    'minimumRefund': PriceDropMinimumRefund;
    'monitoringDuration': PriceDropMonitoringDuration;
}


export interface IsRebook {
    'originalItineraryId': string;
    'DisruptionProtectionRebook': DisruptionProtectionRebookEnum;
}


export interface ItineraryBaggage {
    'orderedExtraBags': OrderedExtraBags;
}
export interface ItineraryFareRules {
    'fareRuleIndex': FareRuleIndex;
    'rules': Array<FareRule>;
}
export interface ItinerarySeats {
    'seats': Array<Seat>;
}
export interface ItinerarySource {
    'sequenceNumber'?: number;
    'created': string;
    'updated': string;
}
/**
 * Ancillary kind
 * @export
 * @enum {string}
 */

export const Kind = {
    CancelOrChange: 'CancelOrChange',
    Cfar: 'Cfar',
    Chfar: 'Chfar',
    Delay: 'Delay',
    Insurance: 'Insurance',
    Luggage: 'Luggage',
    MissedConnection: 'MissedConnection'
} as const;

export type Kind = typeof Kind[keyof typeof Kind];


/**
 * @type LegacyPayment
 * @export
 */
export type LegacyPayment = { tag: 'cc' } & CreditCard;

export const LegacyPaymentEnum = {
    cc: 'cc'
} as const;

export type LegacyPaymentEnum = typeof LegacyPaymentEnum[keyof typeof LegacyPaymentEnum];


export interface Location {
    'locationCode': string;
    'terminalName'?: string;
    'terminalCode'?: string;
}
export interface LuggageId {
    'productId': string;
    'ProtectionId'?: ProtectionIdEnum;
}


export interface MarkedEligible {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


export interface Mass {
    'value': number;
    'unit': string;
}
/**
 * @type MaybePersonResponse
 * @export
 */
export type MaybePersonResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & MaybePersonSuccess;

export const MaybePersonResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type MaybePersonResponseEnum = typeof MaybePersonResponseEnum[keyof typeof MaybePersonResponseEnum];


export interface MaybePersonSuccess {
    'value'?: Person;
    'Response': MaybePersonResponseEnum;
}


/**
 * @type MessageMethod
 * For users who did not buy FDA, when present, sets user\'s preferences for receiving push/sms notifications for disruption events for this booking.
 * @export
 */
export type MessageMethod = { MessageMethod: 'Email' } & Email | { MessageMethod: 'MultiMethod' } & MultiMethod | { MessageMethod: 'Push' } & Push | { MessageMethod: 'Sms' } & Sms;

export const MessageMethodEnum = {
    Email: 'Email',
    MultiMethod: 'MultiMethod',
    Push: 'Push',
    Sms: 'Sms'
} as const;

export type MessageMethodEnum = typeof MessageMethodEnum[keyof typeof MessageMethodEnum];


export interface MinimumDelay {
    'minutes': number;
}
/**
 * `paxCount` - contract.premium.paxCount
 * `postBookingPaymentId` - if it is a post booking purchase, can include the payment from contract.paymentContext
 * @export
 * @interface MissedConnection
 */
export interface MissedConnection {
    /**
     * contract.premium.paxCount
     * @type {number}
     * @memberof MissedConnection
     */
    'paxCount'?: number;
    /**
     * if it is a post booking purchase, can include the payment from contract.paymentContext
     * @type {string}
     * @memberof MissedConnection
     */
    'postBookingPaymentId'?: string;
    'id': MissedConnectionId;
    'status': DisruptionContractStatus;
    'policyDetails'?: PolicyDetails;
    'created': string;
}
/**
 * `quoteId` - the quote id of the disruption offer if it was created with disruption-offers
 * @export
 * @interface MissedConnectionId
 */
export interface MissedConnectionId {
    'ProtectionPolicyId'?: ProtectionPolicyIdEnum;
    'policyId': string;
    'productId': string;
    'ProtectionId'?: ProtectionIdEnum;
    /**
     * the quote id of the disruption offer if it was created with disruption-offers
     * @type {string}
     * @memberof MissedConnectionId
     */
    'quoteId'?: string;
}


export interface MissedConnections {
    'EventCovered': EventCoveredEnum;
}


export interface MoveToQueue {
    'UserDenyFlow': UserDenyFlowEnum;
}


export interface MultiMethod {
    'push'?: Push;
    'email'?: Email;
    'sms'?: Sms;
    'MessageMethod': MessageMethodEnum;
}


export interface MultiProvider {
    'agent': AgentLocator;
    'b2b': string;
    'children': Array<SingleProvider>;
}
export const MultiTicketType = {
    hackerFare: 'hackerFare',
    single: 'single',
    virtualInterline: 'virtualInterline'
} as const;

export type MultiTicketType = typeof MultiTicketType[keyof typeof MultiTicketType];


export interface MultiTravelItinerary {
    'hasEmbeddedRoundTrip': boolean;
    'travelItineraries': Array<SingleTravelItinerary>;
    'TravelItinerary': TravelItineraryEnum;
    'slices': Array<FlightItinerarySlice>;
    'locators'?: MultiProvider;
}


/**
 * A national identification number like a CPF number in Brazil.

 * `number` - The national identification number.
 * `expiration` - The expiration date. For national ids that technically don't expire like the CPF number, this should be left empty.
 * @export
 * @interface NationalId
 */
export interface NationalId {
    /**
     * The national identification number.
     * @type {string}
     * @memberof NationalId
     */
    'number': string;
    /**
     * The expiration date. For national ids that technically don't expire like the CPF number, this should be left empty.
     * @type {string}
     * @memberof NationalId
     */
    'expiration'?: string;
}
export interface Nationality {
    /**
     * 2 character country code
     * @type {string}
     * @memberof Nationality
     */
    'country': string;
}
export interface NavitaireNdcBrand {
    'brandId'?: string;
    'brandName': string;
}
export interface NotAllowed {
    'Reason': ReasonEnum;
}


export interface NotEligible {
    'reason'?: string;
    'PriceDropProtection': PriceDropProtectionEnum;
}


export interface NotRebook {
    'DisruptionProtectionRebook': DisruptionProtectionRebookEnum;
}


/**
 * @type OrderedExtraBags
 * @export
 */
export type OrderedExtraBags = { OrderedExtraBags: 'AllPassengerExtraBags' } & AllPassengerExtraBags | { OrderedExtraBags: 'PerPassengerExtraBags' } & PerPassengerExtraBags;

export const OrderedExtraBagsEnum = {
    AllPassengerExtraBags: 'AllPassengerExtraBags',
    PerPassengerExtraBags: 'PerPassengerExtraBags'
} as const;

export type OrderedExtraBagsEnum = typeof OrderedExtraBagsEnum[keyof typeof OrderedExtraBagsEnum];


/**
 * This is a subset of data from hopper.air.flights.v2.OrderedProductPublicDetails
 * @export
 * @interface OrderedFlight
 */
export interface OrderedFlight {
    'travelItinerary': TravelItinerary;
    'pricingSummary': TripPricingSummary;
    'trackingProperties': TrackingProperties;
}
export interface PassengerAncillaryPricing {
    'kind': Kind;
    'premium': Prices;
}


export interface PassengerError {
    'code': string;
    'message': string;
}
export interface PassengerId {
    'value': string;
}
export const PassengerRequirement = {
    nationalId: 'nationalId',
    nationality: 'nationality',
    passport: 'passport',
    unknown: 'unknown'
} as const;

export type PassengerRequirement = typeof PassengerRequirement[keyof typeof PassengerRequirement];


export interface PassengerTripPricing {
    'baseWithoutMargin': Prices;
    'chfar'?: Prices;
    'additionalMargin'?: Prices;
    'ancillaries': Array<PassengerAncillaryPricing>;
    'total': Prices;
    'passengerType': string;
    'taxes': Prices;
    'person': Person;
    'passengerFee': Prices;
    'currency': string;
    'subtotal': Prices;
}
export interface PassengerWarning {
    'code': string;
    'message': string;
}
export interface PassengersForFareRequest {
    'priceFreezeId'?: string;
    'seatedPassengers': Array<string>;
    'ancillaryIds': Array<ProtectionId>;
    'tripId': string;
    'fareId': string;
    'chfarQuoteId'?: string;
    'lapInfants': Array<string>;
}
export interface PassengersOk {
    'PassengersResponse': PassengersResponseEnum;
}


/**
 * @type PassengersResponse
 * @export
 */
export type PassengersResponse = { PassengersResponse: 'InvalidPassengers' } & InvalidPassengers | { PassengersResponse: 'PassengersOk' } & PassengersOk;

export const PassengersResponseEnum = {
    InvalidPassengers: 'InvalidPassengers',
    PassengersOk: 'PassengersOk'
} as const;

export type PassengersResponseEnum = typeof PassengersResponseEnum[keyof typeof PassengersResponseEnum];


export interface Passport {
    /**
     * 2 character country code
     * @type {string}
     * @memberof Passport
     */
    'countryOfIssue': string;
    'number': string;
    'expiration': string;
}
/**
 * `Payment` types require shared, known types between client and server. `OpaqueValue`
is used to serialize and deserialize models related to specific `Payment`, but avoid coupling
this purchase interface to the specific `Payment` implementation.

### Attributes
 * `PaymentModel.Create` **required**
 *    Request model used to add the payment to an order during checkout.
 * `PaymentModel.Authorize` **optional**
 *    Request model used to fulfill a payment challenge during the 

 * PaymentModel.Quoted **optional** 
 *    Model displayed for payments added prior to "Confirm and Book" shown in the "Payment Breakdown".

 * PaymentModel.ListView - **required** 
 *    Model used to display charged amount on confirmation page, my trips, or any other post-booking display.
 * PaymentModel.Error - **required** 
 *    Error model when processing the payment.

* `AirChfarExerciseDiscount` - Representation of a discount from exercising a Chfar on a new flight.\n
    Interface defined in `b2b-interfaces/air-chfar`.
* `AirPriceFreezeExerciseDiscount` - Representation of the discount price delta from exercising a price freeze on a frozen flight.\n
    Interface defined in `b2b-interfaces/air-price-freeze`.
* `ApplePay` - Payments performed through Apple Pay.\n
    Interface defined in `b2bportal-tripadvisor-bff`.
* `Card` - Payments made via Spreedly card api. Allows orders to be purchased with credit or debit cards.\n
    Interface defined in `b2b-interfaces/card`.
* `DisruptionProtectionCredit` - Representation of the exercising of a disruption protection, on a new flight.\n
    Interface defined in `Tysons/server`.
* `FintechBundleDiscount` - Representation of a synthetic discount for selecting both disruption protection + CFAR offers.\n
    Interface defined in `b2b-interfaces/air-disruption`.,
    
* `GooglePay` - Payments performed through Google Pay.\n
    Interface defined in `b2bportal-tripadvisor-bff`.
* `HotelPriceFreezeDeposit` - Representation of a discount for purchasing a frozen hotel, amounting to the value of the price freeze.\n
    Interface defined in `Tysons/server`.
* `HotelPriceFreezeExerciseDiscount` - Representation of a discount for purchasing a frozen hotel, amounting to the discount price delta from
    exercising of the price freeze.\n
    Interface defined in `Tysons/server`.
* `KCP` - Payments performed through Korea Cyber Payment (KCP).\n
    Interface defined in `b2b-interfaces/payment-methods`.
* `LodgingCfarDiscount` - Representation of a discount applied to an order from a negative lodging CFAR premium\n
    Interface defined in `b2b-interfaces/lodging-cfar`.
* `NequiPocketPayment` - Payments via nequi pocket pay. Can only be used for tenant=nequi.\n
    Interface defined in `b2bportal-nequi-bff`.
* `NupayPayment` - Nubank, tenant specific, payment integration. Can only be used for tenant=nubank.\n
    Interface defined in `b2bportal-nubank-bff`.
* `PackageSyntheticDiscount` - Representation of a synthetic discount for booking a hotel+flight package.\n
    Interface defined in `Tysons/server`.
* `PayPal` - Payments performed through PayPal.\n
    Interface defined in `b2bportal-hopper-web-bff`.
* `PriceFreezeExerciseDiscount` - Representation of a discount for purchasing a frozen product, amounting to the discount price delta from
    exercising of the price freeze.\n
    Interface defined in `b2b-interfaces/pricefreeze`.
* `Rewards` - Payments made via Capital One travel rewards. Can only be used for tenant=capone,capone-corporate.\n
    Interface defined in `Tysons/server`
* `TravelWalletCredit` - Representation of travel wallet credits or carror cash, stored in `Scranton`.\n
    Interface defined in `Tysons/server`.
* `TravelWalletOffer` - Representation of any offer sourced from `Scranton`.\n
    Interface defined in `Tysons/server`.
* `UberPayment` - Uber operated payment processor. Can only be used for tenant=uber.\n
    Interface defined in `b2bportal-uber-bff`.
* `VirginAuVffPoints` - Representation of Virgin Australia's Velocity Frequent Flyer Points which can be used to purchase travel.\n
    Interface defined in `b2bportal-virgin-au-bff`.,
    
* `Wallet` - Payments performed through `Scranton` wallet.\n
    Interface defined in `b2bportal-tripadvisor-bff`.
 * @export
 * @enum {string}
 */

export const Payment = {
    AirChfarExerciseDiscount: 'AirChfarExerciseDiscount',
    AirPriceFreezeExerciseDiscount: 'AirPriceFreezeExerciseDiscount',
    ApplePay: 'ApplePay',
    Card: 'Card',
    DisruptionProtectionCredit: 'DisruptionProtectionCredit',
    FintechBundleDiscount: 'FintechBundleDiscount',
    GooglePay: 'GooglePay',
    HotelPriceFreezeDeposit: 'HotelPriceFreezeDeposit',
    HotelPriceFreezeExerciseDiscount: 'HotelPriceFreezeExerciseDiscount',
    KCP: 'KCP',
    LodgingCfarDiscount: 'LodgingCfarDiscount',
    NequiPocketPayment: 'NequiPocketPayment',
    NupayPayment: 'NupayPayment',
    PackageSyntheticDiscount: 'PackageSyntheticDiscount',
    PayPal: 'PayPal',
    PriceFreezeExerciseDiscount: 'PriceFreezeExerciseDiscount',
    Rewards: 'Rewards',
    TravelWalletCredit: 'TravelWalletCredit',
    TravelWalletOffer: 'TravelWalletOffer',
    UberPayment: 'UberPayment',
    VirginAuVffPoints: 'VirginAuVffPoints',
    Wallet: 'Wallet'
} as const;

export type Payment = typeof Payment[keyof typeof Payment];


/**
 * @type PaymentAmount
 * @export
 */
export type PaymentAmount = { PaymentAmount: 'FiatAmount' } & FiatAmount | { PaymentAmount: 'RewardsAmount' } & RewardsAmount | { PaymentAmount: 'SplitAmount' } & SplitAmount;

export const PaymentAmountEnum = {
    FiatAmount: 'FiatAmount',
    RewardsAmount: 'RewardsAmount',
    SplitAmount: 'SplitAmount'
} as const;

export type PaymentAmountEnum = typeof PaymentAmountEnum[keyof typeof PaymentAmountEnum];


/**
 * This model is attached to each itinerary in order to display a payment breakdown in My Trips

 * `payments` - deprecated, use `paymentLineItems` instead
 * `paymentLineItems` - All payments used in the purchase of the Itinerary.
 * @export
 * @interface PaymentBreakdown
 */
export interface PaymentBreakdown {
    /**
     * deprecated, use `paymentLineItems` instead
     * @type {Array<PaymentLineItem>}
     * @memberof PaymentBreakdown
     */
    'payments': Array<PaymentLineItem>;
    /**
     * All payments used in the purchase of the Itinerary.
     * @type {Array<PaymentOpaqueValue>}
     * @memberof PaymentBreakdown
     */
    'paymentLineItems': Array<PaymentOpaqueValue>;
}
export interface PaymentClientToken {
    'value': string;
}
export interface PaymentFulfillmentService {
    'value': string;
    'ID': IDEnum;
}


/**
 * @type PaymentLineItem
 * @export
 */
export type PaymentLineItem = { PaymentLineItem: 'AncillaryCredit' } & PaymentLineItemAncillaryCredit | { PaymentLineItem: 'FintechBundleDiscount' } & PaymentLineItemFintechBundleDiscount | { PaymentLineItem: 'NequiAccount' } & PaymentLineItemNequiAccount | { PaymentLineItem: 'NupayCredit' } & PaymentLineItemNupayCredit | { PaymentLineItem: 'NupayDebit' } & PaymentLineItemNupayDebit | { PaymentLineItem: 'Rewards' } & PaymentLineItemRewards | { PaymentLineItem: 'TravelWallet' } & PaymentLineItemTravelWallet | { PaymentLineItem: 'UberCredit' } & PaymentLineItemUberCredit | { PaymentLineItem: 'UserCard' } & PaymentLineItemUserCard;

/**
 * @type PaymentLineItemAncillaryCredit
 * @export
 */
export type PaymentLineItemAncillaryCredit = { AncillaryCredit: 'ChfarCredit' } & ChfarCredit | { AncillaryCredit: 'DisruptionProtectionCredit' } & DisruptionProtectionCredit | { AncillaryCredit: 'PriceFreezeCredit' } & PriceFreezeCredit;

export const PaymentLineItemAncillaryCreditEnum = {
    ChfarCredit: 'ChfarCredit',
    DisruptionProtectionCredit: 'DisruptionProtectionCredit',
    PriceFreezeCredit: 'PriceFreezeCredit'
} as const;

export type PaymentLineItemAncillaryCreditEnum = typeof PaymentLineItemAncillaryCreditEnum[keyof typeof PaymentLineItemAncillaryCreditEnum];


export const PaymentLineItemEnum = {
    AncillaryCredit: 'AncillaryCredit',
    FintechBundleDiscount: 'FintechBundleDiscount',
    NequiAccount: 'NequiAccount',
    NupayCredit: 'NupayCredit',
    NupayDebit: 'NupayDebit',
    Rewards: 'Rewards',
    TravelWallet: 'TravelWallet',
    UberCredit: 'UberCredit',
    UserCard: 'UserCard'
} as const;

export type PaymentLineItemEnum = typeof PaymentLineItemEnum[keyof typeof PaymentLineItemEnum];


/**
 * This model is used by Hopper web for a discount offered when both Disruption and CFAR products are attached.
 * @export
 * @interface PaymentLineItemFintechBundleDiscount
 */
export interface PaymentLineItemFintechBundleDiscount {
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
}


/**
 * This model represents a Nequi account that contains fiat currency values
 * @export
 * @interface PaymentLineItemNequiAccount
 */
export interface PaymentLineItemNequiAccount {
    'pocketName': string;
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
}


/**
 * A payment made in multiple installments via Nupay.
 * @export
 * @interface PaymentLineItemNupayCredit
 */
export interface PaymentLineItemNupayCredit {
    'amount': FiatAmount;
    'fees'?: FiatAmount;
    'numberOfInstallments'?: number;
    'PaymentLineItem': PaymentLineItemEnum;
}


/**
 * A payment made by debiting against a Nubank account balance.
 * @export
 * @interface PaymentLineItemNupayDebit
 */
export interface PaymentLineItemNupayDebit {
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
}


/**
 * This model represents rewards (points/miles/cash), which can be earned through Capital One cards.
 * @export
 * @interface PaymentLineItemRewards
 */
export interface PaymentLineItemRewards {
    'accountDisplayName': string;
    'amount': RewardsAmount;
    'PaymentLineItem': PaymentLineItemEnum;
}


/**
 * @type PaymentLineItemTravelWallet
 * This model is used for Capital One Travel Wallet utilizing Scranton\'s offers and credits.
 * @export
 */
export type PaymentLineItemTravelWallet = { TravelWallet: 'TravelWalletCredit' } & TravelWalletCredit | { TravelWallet: 'TravelWalletOffer' } & TravelWalletOffer;

export const PaymentLineItemTravelWalletEnum = {
    TravelWalletCredit: 'TravelWalletCredit',
    TravelWalletOffer: 'TravelWalletOffer'
} as const;

export type PaymentLineItemTravelWalletEnum = typeof PaymentLineItemTravelWalletEnum[keyof typeof PaymentLineItemTravelWalletEnum];


/**
 * This model represents an Uber payment (UberCredit or credit card) that contains fiat currency values
 * @export
 * @interface PaymentLineItemUberCredit
 */
export interface PaymentLineItemUberCredit {
    'label': string;
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
}


export interface PaymentLineItemUserCard {
    'cardNumberDisplay': string;
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
}


export interface PaymentMachine {
    'token': PaymentClientToken;
    'ID': IDEnum;
}


/**
 * Model used to generify shared types across any product or payment type. The type of `OpaqueValue`
is a shared value between the FE and BFF. As a result each implementation of the purchase interface
can use different products/payments or even different versions of products or payments.
 * @export
 * @interface PaymentOpaqueValue
 */
export interface PaymentOpaqueValue {
    'type': Payment;
    'value': any;
}


/**
 * This model is deprecated in favor of the new model [[PaymentBreakdown]].
This [[PaymentsAndCredits]] model doesn't work when a user pays for a trip without a card or rewards
 * @export
 * @interface PaymentsAndCredits
 */
export interface PaymentsAndCredits {
    'credits': Array<Credit>;
    'travelWalletPayments': Array<TravelWallet>;
}
/**
 * @type PenaltiesInfo
 * @export
 */
export type PenaltiesInfo = { PenaltiesInfo: 'ExternallyManaged' } & PenaltiesInfoExternallyManaged | { PenaltiesInfo: 'Known' } & PenaltiesInfoKnown | { PenaltiesInfo: 'Unknown' } & PenaltiesInfoUnknown;

export const PenaltiesInfoEnum = {
    ExternallyManaged: 'ExternallyManaged',
    Known: 'Known',
    Unknown: 'Unknown'
} as const;

export type PenaltiesInfoEnum = typeof PenaltiesInfoEnum[keyof typeof PenaltiesInfoEnum];


export interface PenaltiesInfoExternallyManaged {
    'code': string;
    'PenaltiesInfo': PenaltiesInfoEnum;
}


export interface PenaltiesInfoKnown {
    'changePenalty': Penalty;
    'cancelPenalty': Penalty;
    'PenaltiesInfo': PenaltiesInfoEnum;
}


export interface PenaltiesInfoUnknown {
    'PenaltiesInfo': PenaltiesInfoEnum;
}


/**
 * @type Penalty
 * @export
 */
export type Penalty = { Penalty: 'NoPenalty' } & PenaltyNoPenalty | { Penalty: 'NotPossible' } & PenaltyNotPossible | { Penalty: 'Unknown' } & PenaltyUnknown | { Penalty: 'WithFee' } & PenaltyWithFee;

export const PenaltyEnum = {
    NoPenalty: 'NoPenalty',
    NotPossible: 'NotPossible',
    Unknown: 'Unknown',
    WithFee: 'WithFee'
} as const;

export type PenaltyEnum = typeof PenaltyEnum[keyof typeof PenaltyEnum];


export interface PenaltyNoPenalty {
    'Penalty': PenaltyEnum;
}


export interface PenaltyNotPossible {
    'Penalty': PenaltyEnum;
}


export interface PenaltyUnknown {
    'Penalty': PenaltyEnum;
}


export interface PenaltyWithFee {
    'amount': number;
    'currency': string;
    'Penalty': PenaltyEnum;
}


/**
 * Model describing ordered extra bags per passenger
 * @export
 * @interface PerPassengerExtraBags
 */
export interface PerPassengerExtraBags {
    'bagsPerPassenger': { [key: string]: ExtraBags; };
    'OrderedExtraBags': OrderedExtraBagsEnum;
}


/**
 * `premium` - premium percentage. e.g.  2.2% expressed as 2.2
 * `coverage` - coverage percentage. e.g.  2.2% expressed as 2.2
 * @export
 * @interface PercentagePolicyDetails
 */
export interface PercentagePolicyDetails {
    /**
     * premium percentage. e.g.  2.2% expressed as 2.2
     * @type {number}
     * @memberof PercentagePolicyDetails
     */
    'premium': number;
    /**
     * coverage percentage. e.g.  2.2% expressed as 2.2
     * @type {number}
     * @memberof PercentagePolicyDetails
     */
    'coverage': number;
    'PolicyDetails': PolicyDetailsEnum;
}


export interface Person {
    'givenName': string;
    'knownTravelerNumber'?: string;
    'phoneNumber'?: string;
    'middleName'?: string;
    'emailAddress'?: string;
    'driverLicense'?: DriverLicense;
    'surname': string;
    'dateOfBirth': string;
    'nationalId'?: NationalId;
    'passport'?: Passport;
    'id': string;
    'frequentFlyer': { [key: string]: FrequentFlyerNumber; };
    'hotelLoyalty': { [key: string]: HotelLoyaltyNumber; };
    'redressNumber'?: string;
    'nationality'?: Nationality;
    'createdAt': string;
    'assistance': Array<Assistance>;
    'lastBookedWith'?: string;
    'gender': Gender;
}


/**
 * Deprecated. Use `payments` field on `quoteBreakdown` instead.
 * @export
 * @interface PersonCredits
 */
export interface PersonCredits {
    'personId': string;
    'priceFreezeExerciseCredit'?: PriceFreezeExercisePersonCredit;
}
/**
 * @type PersonListResponse
 * @export
 */
export type PersonListResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & PersonListSuccess;

export const PersonListResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type PersonListResponseEnum = typeof PersonListResponseEnum[keyof typeof PersonListResponseEnum];


export interface PersonListSuccess {
    'value': Array<Person>;
    'Response': PersonListResponseEnum;
}


/**
 * @type PolicyDetails
 * @export
 */
export type PolicyDetails = { PolicyDetails: 'FixedPolicyDetails' } & FixedPolicyDetails | { PolicyDetails: 'PercentagePolicyDetails' } & PercentagePolicyDetails;

export const PolicyDetailsEnum = {
    FixedPolicyDetails: 'FixedPolicyDetails',
    PercentagePolicyDetails: 'PercentagePolicyDetails'
} as const;

export type PolicyDetailsEnum = typeof PolicyDetailsEnum[keyof typeof PolicyDetailsEnum];


export const PortalItineraryStatus = {
    Canceled: 'Canceled',
    Confirmed: 'Confirmed',
    Modified: 'Modified',
    Pending: 'Pending'
} as const;

export type PortalItineraryStatus = typeof PortalItineraryStatus[keyof typeof PortalItineraryStatus];


export const PostTicketingStatus = {
    Canceled: 'Canceled',
    Modified: 'Modified',
    Rejected: 'Rejected',
    Ticketed: 'Ticketed'
} as const;

export type PostTicketingStatus = typeof PostTicketingStatus[keyof typeof PostTicketingStatus];


export interface PriceDropMaximumRefund {
    'display': string;
    'amount': Amount;
}
export interface PriceDropMinimumRefund {
    'display': string;
    'amount': Amount;
}
export interface PriceDropMonitoringDuration {
    'inSeconds': number;
}
/**
 * @type PriceDropProtection
 * @export
 */
export type PriceDropProtection = { PriceDropProtection: 'IsEligible' } & IsEligible | { PriceDropProtection: 'NotEligible' } & NotEligible;

export const PriceDropProtectionEnum = {
    IsEligible: 'IsEligible',
    NotEligible: 'NotEligible'
} as const;

export type PriceDropProtectionEnum = typeof PriceDropProtectionEnum[keyof typeof PriceDropProtectionEnum];


export interface PriceFreezeCredit {
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
    'AncillaryCredit': PaymentLineItemAncillaryCreditEnum;
}


/**
 * When present, indicates a Price Freeze voucher is being exercised for this booking.
 * @export
 * @interface PriceFreezeExercise
 */
export interface PriceFreezeExercise {
    'voucherId': string;
}
export interface PriceFreezeExercisePersonCredit {
    'creditAmount': Prices;
}
/**
 * Deprecated. Use `payments` field on `quoteBreakdown` instead.
 * @export
 * @interface PriceFreezeExerciseTripCredit
 */
export interface PriceFreezeExerciseTripCredit {
    'priceFreezeId': string;
    'frozenPaxCount': number;
    'offerPerPaxCap'?: Prices;
    'perFrozenPaxSavings': Prices;
    'offerFrozenPerPaxPrice': Prices;
    'creditAmount': Prices;
}
/**
 * `creditSummary` - Deprecated. Use `payments` field on `quoteBreakdown` instead.
 * @export
 * @interface PriceQuoteData
 */
export interface PriceQuoteData {
    'itinerary': PricedFlightItinerary;
    'creditSummary'?: FlightCreditSummary;
    'seatMap'?: SeatMapResponse;
}
export interface PricedFlightItinerary {
    'sellingPricing': TripPricingSummary;
    'bookingProviderName': string;
    'restrictions'?: Restrictions;
    'faresRules': FareRules;
    'id': string;
    'guaranteedTicketing'?: boolean;
    'tripAncillaries': TripAncillaryIds;
}
/**
 * Price in fiat currency as well as any with rewards/account specific currency
 * @export
 * @interface Prices
 */
export interface Prices {
    'fiat': FiatPrice;
    'accountSpecific': { [key: string]: AccountPrice; };
}
export interface ProductId {
    'value': string;
}
/**
 * @type ProtectionId
 * @export
 */
export type ProtectionId = { ProtectionId: 'InsuranceId' } & InsuranceId | { ProtectionId: 'LuggageId' } & LuggageId | { ProtectionId: 'ProtectionPolicyId' } & ProtectionPolicyId;

export const ProtectionIdEnum = {
    InsuranceId: 'InsuranceId',
    LuggageId: 'LuggageId',
    ProtectionPolicyId: 'ProtectionPolicyId'
} as const;

export type ProtectionIdEnum = typeof ProtectionIdEnum[keyof typeof ProtectionIdEnum];


/**
 * @type ProtectionPolicyId
 * @export
 */
export type ProtectionPolicyId = { ProtectionPolicyId: 'CancelOrChangeId' } & CancelOrChangeId | { ProtectionPolicyId: 'CfarId' } & CfarId | { ProtectionPolicyId: 'ChfarId' } & ChfarId | { ProtectionPolicyId: 'DelayId' } & DelayId | { ProtectionPolicyId: 'MissedConnectionId' } & MissedConnectionId;

export const ProtectionPolicyIdEnum = {
    CancelOrChangeId: 'CancelOrChangeId',
    CfarId: 'CfarId',
    ChfarId: 'ChfarId',
    DelayId: 'DelayId',
    MissedConnectionId: 'MissedConnectionId'
} as const;

export type ProtectionPolicyIdEnum = typeof ProtectionPolicyIdEnum[keyof typeof ProtectionPolicyIdEnum];


/**
 * deprecated
 * @export
 * @interface Purchase
 */
export interface Purchase {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


export interface PurchaseResult {
    'itinerary': BookedFlightItinerary;
}
export interface PurchaseTimeDiscount {
    'discount': Prices;
    'lineItemName': string;
}
export interface Push {
    'MessageMethod'?: MessageMethodEnum;
}


/**
 * This is a subset of data from hopper.air.flights.v2.ShoppedProductPublicDetails

 * `bookingSessionId` - DEPRECATED - Brooklyn Booking Session. Temporarily used to attach ancillaries like seats
 * `seatMap` - Populated with Gordian SeatMap if seats are available.
 * `shoppedTripId` - Shopped tripId. Used for attaching ancillary products like seats
 * @export
 * @interface QuotedFlight
 */
export interface QuotedFlight {
    'seatsClientToken'?: string;
    /**
     * DEPRECATED - Brooklyn Booking Session. Temporarily used to attach ancillaries like seats
     * @type {string}
     * @memberof QuotedFlight
     */
    'bookingSessionId'?: string;
    'reservationId'?: string;
    'pricingSummary': TripPricingSummary;
    'trackingProperties': TrackingProperties;
    'seatMap'?: SeatMapResponse;
    /**
     * Shopped tripId. Used for attaching ancillary products like seats
     * @type {string}
     * @memberof QuotedFlight
     */
    'shoppedTripId'?: string;
}
/**
 * @type Reason
 * @export
 */
export type Reason = { Reason: 'AlreadyDone' } & AlreadyDone | { Reason: 'ContactAirline' } & ContactAirline | { Reason: 'ContactSupport' } & ContactSupport | { Reason: 'NotAllowed' } & NotAllowed;

export const ReasonEnum = {
    AlreadyDone: 'AlreadyDone',
    ContactAirline: 'ContactAirline',
    ContactSupport: 'ContactSupport',
    NotAllowed: 'NotAllowed'
} as const;

export type ReasonEnum = typeof ReasonEnum[keyof typeof ReasonEnum];


/**
 * deprecated
 * @export
 * @interface Rebook
 */
export interface Rebook {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


/**
 * the contract is eligible to be redeemed through Rebooking only
 * @export
 * @interface RebookOnlyEligible
 */
export interface RebookOnlyEligible {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


/**
 * deprecated
 * @export
 * @interface Redeem
 */
export interface Redeem {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


export interface ReferToAirline {
    'UserDenyFlow': UserDenyFlowEnum;
}


/**
 * deprecated
 * @export
 * @interface Refund
 */
export interface Refund {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


/**
 * deprecated
 * @export
 * @interface Remove
 */
export interface Remove {
    'DisruptionContractStatus': DisruptionContractStatusEnum;
}


export interface Restrictions {
    'penaltiesInfo': PenaltiesInfo;
    'baggageInfo': BaggageInfo;
    'seatMapInfoAvailable': boolean;
}
/**
 * @type RewardProgram
 * @export
 */
export type RewardProgram = { RewardProgram: 'SkyBonus' } & SkyBonus;

export const RewardProgramEnum = {
    SkyBonus: 'SkyBonus'
} as const;

export type RewardProgramEnum = typeof RewardProgramEnum[keyof typeof RewardProgramEnum];


export interface RewardsAmount {
    'rewardsAccountId': string;
    'fiatValue': Amount;
    'rewardsPrice': AccountPrice;
    'PaymentAmount'?: PaymentAmountEnum;
}


export interface SabreBrand {
    'brandId': string;
    'brandName'?: string;
}
/**
 * @type ScanResult
 * @export
 */
export type ScanResult = { ScanResult: 'AsIs' } & ScanResultAsIs | { ScanResult: 'NotAvailable' } & ScanResultNotAvailable | { ScanResult: 'NotScanned' } & ScanResultNotScanned | { ScanResult: 'WithEdits' } & ScanResultWithEdits;

export interface ScanResultAsIs {
    'ScanResult': ScanResultEnum;
}


export const ScanResultEnum = {
    AsIs: 'AsIs',
    NotAvailable: 'NotAvailable',
    NotScanned: 'NotScanned',
    WithEdits: 'WithEdits'
} as const;

export type ScanResultEnum = typeof ScanResultEnum[keyof typeof ScanResultEnum];


export interface ScanResultNotAvailable {
    'ScanResult': ScanResultEnum;
}


export interface ScanResultNotScanned {
    'ScanResult': ScanResultEnum;
}


export interface ScanResultWithEdits {
    'fields': Array<ScannedField>;
    'ScanResult': ScanResultEnum;
}


export const ScannedField = {
    card_number: 'card_number',
    expiration_date: 'expiration_date'
} as const;

export type ScannedField = typeof ScannedField[keyof typeof ScannedField];


/**
 * `prev` - Flight slices before reschedule.
 * @export
 * @interface ScheduleChange
 */
export interface ScheduleChange {
    /**
     * Flight slices before reschedule.
     * @type {Array<FlightItinerarySlice>}
     * @memberof ScheduleChange
     */
    'prev'?: Array<FlightItinerarySlice>;
    'id': string;
    'next'?: Array<FlightItinerarySlice>;
    'severity': ScheduleChangeSeverity;
    'expiry': string;
    'userDenyFlow': UserDenyFlow;
    'created': string;
}


export interface ScheduleChangeChoice {
    'departAfter': string;
    'departBefore': string;
}
export const ScheduleChangeSeverity = {
    Major: 'Major',
    Minor: 'Minor',
    Unknown: 'Unknown'
} as const;

export type ScheduleChangeSeverity = typeof ScheduleChangeSeverity[keyof typeof ScheduleChangeSeverity];


/**
 * `sendFlightNotificationPreferences` - For users who did not buy FDA, when present, sets user's preferences for receiving push/sms notifications for disruption events for this booking.
 * `priceFreezeExercise` - When present, indicates a Price Freeze voucher is being exercised for this booking.
 * `chfarQuoteId` - When present, indicates air ChFAR was attached to this booking.
 * `disruptionProtection` - This field is specified to indicate the request is for exercising a purchased Disruption Protection product and rebooking a disrupted flight. For a normal booking, this field should be set to None
 * `chfarExercise` - When present, indicates a chfar contract is being exercised for this booking.
 * `disruptionNotificationPreferences` - When present, sets user's preferences for receiving push/sms notifications for disruption events for this booking.
 * `metaSearchChannel` - When present, indicates the metasearch source that led the user to our booking flow. i.e: google
 * @export
 * @interface SchedulePriceQuoteRequest
 */
export interface SchedulePriceQuoteRequest {
    'sendFlightNotificationPreferences'?: MessageMethod;
    'priceDropCandidateId'?: string;
    'seatedPassengers': Array<string>;
    /**
     * A phone Number. The frontend should validate the phone number since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof SchedulePriceQuoteRequest
     */
    'phoneNumber': string;
    'ancillaryIds': Array<ProtectionId>;
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof SchedulePriceQuoteRequest
     */
    'emailAddress': string;
    'tripId': string;
    'priceFreezeExercise'?: PriceFreezeExercise;
    'fareId': string;
    /**
     * When present, indicates air ChFAR was attached to this booking.
     * @type {string}
     * @memberof SchedulePriceQuoteRequest
     */
    'chfarQuoteId'?: string;
    'delegatedTo'?: string;
    'disruptionProtection'?: DisruptionProtection;
    'rewardPrograms': Array<RewardProgram>;
    'chfarExercise'?: ChfarExercise;
    'disruptionNotificationPreferences'?: MessageMethod;
    /**
     * When present, indicates the metasearch source that led the user to our booking flow. i.e: google
     * @type {string}
     * @memberof SchedulePriceQuoteRequest
     */
    'metaSearchChannel'?: string;
    'lapInfants': Array<string>;
}
export interface Seat {
    'departureTime'?: string;
    'seatId': SeatId;
    'airlinePnr'?: string;
    'personId': string;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof Seat
     */
    'carrier': string;
    'price': number;
    'outgoing': boolean;
    'arrivalTime'?: string;
    'id': SeatUniqueId;
    'displayString': string;
    'origin': string;
    'purchaseId': string;
    'currency': string;
    'productId': ProductId;
    'markupPrice'?: number;
    'destination': string;
    'passengerId': PassengerId;
}
export interface SeatId {
    'value': string;
}
export interface SeatMapAvailable {
    'callback': SeatMapCallback;
    'seatsInfo'?: SeatsInfo;
    'SeatMapResponse': SeatMapResponseEnum;
}


export interface SeatMapCallback {
    'value': any;
}
/**
 * @type SeatMapResponse
 * @export
 */
export type SeatMapResponse = { SeatMapResponse: 'SeatMapAvailable' } & SeatMapAvailable | { SeatMapResponse: 'SeatMapUnavailable' } & SeatMapUnavailable;

export const SeatMapResponseEnum = {
    SeatMapAvailable: 'SeatMapAvailable',
    SeatMapUnavailable: 'SeatMapUnavailable'
} as const;

export type SeatMapResponseEnum = typeof SeatMapResponseEnum[keyof typeof SeatMapResponseEnum];


export interface SeatMapUnavailable {
    'SeatMapResponse': SeatMapResponseEnum;
}


export interface SeatSegment {
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof SeatSegment
     */
    'origin': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof SeatSegment
     */
    'destination': string;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof SeatSegment
     */
    'carrier': string;
    'seatsAvailable': boolean;
}
export interface SeatSlice {
    'segments': Array<SeatSegment>;
}
export interface SeatUniqueId {
    'value': number;
}
export interface SeatedPassengers {
    'withLapInfants': Array<AdultWithLapInfant>;
    'alone': Array<AssociatedPassenger>;
    'contact': AssociatedContact;
}
export interface SeatsInfo {
    'slices': Array<SeatSlice>;
}
export interface SegmentAirlineInfo {
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof SegmentAirlineInfo
     */
    'code': string;
    'flightNumber': number;
    'locator'?: string;
}
export interface SegmentShelf {
    'rating': number;
    'brandName': string;
    'shortBrandName': string;
    'opaqueMapperStep'?: string;
}
export interface SingleFlightItineraryRequest {
    'itineraryId': string;
    'referenceDateTime': string;
}
export interface SingleFlightItineraryResponse {
    'itinerary': BookedFlightItineraryWithDepartureTime;
    'context': TripContext;
}
export interface SingleProvider {
    'agent': AgentLocator;
    'b2b': string;
}
export interface SingleTravelItinerary {
    'ticketing': Array<Ticketing>;
    'hasEmbeddedRoundTrip': boolean;
    'postTicketingStatus'?: PostTicketingStatus;
    'TravelItinerary'?: TravelItineraryEnum;
    'supportContact': SupportContact;
    'slices': Array<FlightItinerarySlice>;
    'locators'?: SingleProvider;
}


export interface SkyBonus {
    'skyBonusID': string;
    'RewardProgram': RewardProgramEnum;
}


export interface Sms {
    'MessageMethod'?: MessageMethodEnum;
}


export interface SplitAmount {
    'fiatAmount': FiatAmount;
    'rewardsAmount': RewardsAmount;
    'PaymentAmount': PaymentAmountEnum;
}


export const Status = {
    Booked: 'Booked',
    Canceled: 'Canceled',
    Modified: 'Modified',
    Pending: 'Pending',
    Priced: 'Priced',
    Problem: 'Problem',
    Rejected: 'Rejected',
    Ticketed: 'Ticketed'
} as const;

export type Status = typeof Status[keyof typeof Status];


export const SupportContact = {
    Airline: 'Airline',
    Hopper: 'Hopper'
} as const;

export type SupportContact = typeof SupportContact[keyof typeof SupportContact];


export interface TicketNumber {
    'number': string;
    'TicketNumberType': TicketNumberTypeEnum;
}


/**
 * @type TicketNumberType
 * @export
 */
export type TicketNumberType = { TicketNumberType: 'InfantNotIssued' } & InfantNotIssued | { TicketNumberType: 'TicketNumber' } & TicketNumber;

export const TicketNumberTypeEnum = {
    InfantNotIssued: 'InfantNotIssued',
    TicketNumber: 'TicketNumber'
} as const;

export type TicketNumberTypeEnum = typeof TicketNumberTypeEnum[keyof typeof TicketNumberTypeEnum];


export interface Ticketing {
    'eTicketNumber': TicketNumberType;
}
export interface TotalAncillaryPricing {
    'kind': Kind;
    'premium': Prices;
}


export interface TotalTripPricing {
    'baseWithoutMargin': Prices;
    'chfar'?: Prices;
    'additionalMargin'?: Prices;
    'ancillaries': Array<TotalAncillaryPricing>;
    'total': Prices;
    'taxes': Prices;
    'passengerFee': Prices;
    'discounts': Array<PurchaseTimeDiscount>;
    'currency': string;
    'subtotal': Prices;
    'tripFee': Prices;
}
export interface TrackingProperties {
    'properties'?: any;
    'encryptedProperties'?: string;
}
export interface TravelCredit {
    'travelDeadline'?: string;
    'credit': Amount;
    'id': string;
    'status': TravelCreditStatus;
    'penalty'?: Amount;
    'route': Array<Location>;
    'rebookDeadline'?: string;
}


export const TravelCreditStatus = {
    Available: 'Available',
    Expired: 'Expired',
    Redeemed: 'Redeemed'
} as const;

export type TravelCreditStatus = typeof TravelCreditStatus[keyof typeof TravelCreditStatus];


export interface TravelFusionBrand {
    'brandId': string;
    'brandName'?: string;
}
/**
 * @type TravelItinerary
 * @export
 */
export type TravelItinerary = { TravelItinerary: 'MultiTravelItinerary' } & MultiTravelItinerary | { TravelItinerary: 'SingleTravelItinerary' } & SingleTravelItinerary;

export const TravelItineraryEnum = {
    MultiTravelItinerary: 'MultiTravelItinerary',
    SingleTravelItinerary: 'SingleTravelItinerary'
} as const;

export type TravelItineraryEnum = typeof TravelItineraryEnum[keyof typeof TravelItineraryEnum];


/**
 * @type TravelWallet
 * @export
 */
export type TravelWallet = { TravelWallet: 'TravelWalletCredit' } & TravelWalletTravelWalletCredit | { TravelWallet: 'TravelWalletOffer' } & TravelWalletTravelWalletOffer;

/**
 * `breakdown` - The granular Scranton credit details that composes TravelWalletCredit. The sum(breakdown) should equal TravelWalletCredit.amount
 * @export
 * @interface TravelWalletCredit
 */
export interface TravelWalletCredit {
    'amount': FiatAmount;
    /**
     * The granular Scranton credit details that composes TravelWalletCredit. The sum(breakdown) should equal TravelWalletCredit.amount
     * @type {Array<TravelWalletCreditDetail>}
     * @memberof TravelWalletCredit
     */
    'breakdown': Array<TravelWalletCreditDetail>;
    'PaymentLineItem': PaymentLineItemEnum;
    'TravelWallet': PaymentLineItemTravelWalletEnum;
}


/**
 * The granular Scranton credit detail

 * `description` - A direct user copy that is localized/specific to the tenant
 * @export
 * @interface TravelWalletCreditDetail
 */
export interface TravelWalletCreditDetail {
    /**
     * A direct user copy that is localized/specific to the tenant
     * @type {string}
     * @memberof TravelWalletCreditDetail
     */
    'description': string;
    'amount': FiatAmount;
}
export const TravelWalletEnum = {
    TravelWalletCredit: 'TravelWalletCredit',
    TravelWalletOffer: 'TravelWalletOffer'
} as const;

export type TravelWalletEnum = typeof TravelWalletEnum[keyof typeof TravelWalletEnum];


export interface TravelWalletOffer {
    'amount': FiatAmount;
    'offerType'?: WalletOfferType;
    'PaymentLineItem': PaymentLineItemEnum;
    'TravelWallet': PaymentLineItemTravelWalletEnum;
}


export interface TravelWalletTravelWalletCredit {
    'amount': FiatAmount;
    'TravelWallet': TravelWalletEnum;
}


export interface TravelWalletTravelWalletOffer {
    'amount': FiatAmount;
    'TravelWallet': TravelWalletEnum;
}


export interface TravelportBrand {
    'brandId': string;
    'brandName'?: string;
    'brandTier'?: number;
}
export interface TripAncillaryContracts {
    'missedConnectionVi'?: MissedConnection;
    'delay'?: Delay;
    'insurance'?: Insurance;
    'chfar'?: Chfar;
    'cfar'?: Cfar;
    'disruptionProtection'?: DisruptionProtectionAncillaryContract;
    'missedConnection'?: MissedConnection;
}
export interface TripAncillaryIds {
    'chfarId'?: ChfarId;
    'cfarId'?: CfarId;
    'missedConnectionId'?: MissedConnectionId;
    'insuranceId'?: InsuranceId;
    'chfarQuoteId'?: string;
    'cancelOrChangeId'?: CancelOrChangeId;
    'luggageId'?: LuggageId;
    'delayId'?: DelayId;
}
export interface TripContext {
    'airports': { [key: string]: Airport; };
    'airlines': { [key: string]: Airline; };
}
/**
 * Deprecated. Use `payments` field on `quoteBreakdown` instead.
 * @export
 * @interface TripCredits
 */
export interface TripCredits {
    'priceFreezeExerciseCredit'?: PriceFreezeExerciseTripCredit;
}
/**
 * `passengerRequirements` - The passenger requirements (ex: passport) for the trip
 * @export
 * @interface TripPricingSummary
 */
export interface TripPricingSummary {
    'totalPricing': TotalTripPricing;
    'pricingByPassenger': Array<PassengerTripPricing>;
    'extraBaggage'?: ExtraBaggageOptions;
    /**
     * The passenger requirements (ex: passport) for the trip
     * @type {Array<PassengerRequirement>}
     * @memberof TripPricingSummary
     */
    'passengerRequirements': Array<PassengerRequirement>;
}
/**
 * @type TripPricingSummaryResponse
 * @export
 */
export type TripPricingSummaryResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & TripPricingSummarySuccess;

export const TripPricingSummaryResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type TripPricingSummaryResponseEnum = typeof TripPricingSummaryResponseEnum[keyof typeof TripPricingSummaryResponseEnum];


export interface TripPricingSummarySuccess {
    'value': TripPricingSummary;
    'Response': TripPricingSummaryResponseEnum;
}


export interface Unavailable {
    'reason': Reason;
    'Availability': AvailabilityEnum;
}


export interface UpdatePassengerRequest {
    'person': Person;
}
/**
 * @type UserDenyFlow
 * @export
 */
export type UserDenyFlow = { UserDenyFlow: 'MoveToQueue' } & MoveToQueue | { UserDenyFlow: 'ReferToAirline' } & ReferToAirline;

export const UserDenyFlowEnum = {
    MoveToQueue: 'MoveToQueue',
    ReferToAirline: 'ReferToAirline'
} as const;

export type UserDenyFlowEnum = typeof UserDenyFlowEnum[keyof typeof UserDenyFlowEnum];


export interface VoidExtension {
    'days': number;
    'at': string;
}
export const WalletOfferType = {
    Promotion: 'Promotion',
    Voucher: 'Voucher'
} as const;

export type WalletOfferType = typeof WalletOfferType[keyof typeof WalletOfferType];


export interface WebLinks {
    'changeCancelPolicy'?: string;
    'otherFee'?: string;
    'checkInPolicy'?: string;
    'wifiFee'?: string;
    'homePage'?: string;
    'baggageFees'?: string;
    'seatUpgrade'?: string;
    'manageBooking'?: string;
    'seatSelection'?: string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete passenger
         * @param {DeletePassengerRequest} deletePassengerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FlightPassengersDeletePost: async (deletePassengerRequest: DeletePassengerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deletePassengerRequest' is not null or undefined
            assertParamExists('apiV0FlightPassengersDeletePost', 'deletePassengerRequest', deletePassengerRequest)
            const localVarPath = `/api/v0/flight/passengers/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deletePassengerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get passenger
         * @param {GetPassengerRequest} getPassengerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FlightPassengersGetPut: async (getPassengerRequest: GetPassengerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getPassengerRequest' is not null or undefined
            assertParamExists('apiV0FlightPassengersGetPut', 'getPassengerRequest', getPassengerRequest)
            const localVarPath = `/api/v0/flight/passengers/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPassengerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all passengers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FlightPassengersListPut: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/flight/passengers/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update passenger
         * @param {UpdatePassengerRequest} updatePassengerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FlightPassengersUpdatePut: async (updatePassengerRequest: UpdatePassengerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePassengerRequest' is not null or undefined
            assertParamExists('apiV0FlightPassengersUpdatePut', 'updatePassengerRequest', updatePassengerRequest)
            const localVarPath = `/api/v0/flight/passengers/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePassengerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accept schedule change
         * @param {AcceptScheduleChangeRequest} acceptScheduleChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ItineraryFlightAcceptScheduleChangePost: async (acceptScheduleChangeRequest: AcceptScheduleChangeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptScheduleChangeRequest' is not null or undefined
            assertParamExists('apiV0ItineraryFlightAcceptScheduleChangePost', 'acceptScheduleChangeRequest', acceptScheduleChangeRequest)
            const localVarPath = `/api/v0/itinerary/flight/acceptScheduleChange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptScheduleChangeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deny schedule change
         * @param {DenyScheduleChangeRequest} denyScheduleChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ItineraryFlightDenyScheduleChangePost: async (denyScheduleChangeRequest: DenyScheduleChangeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'denyScheduleChangeRequest' is not null or undefined
            assertParamExists('apiV0ItineraryFlightDenyScheduleChangePost', 'denyScheduleChangeRequest', denyScheduleChangeRequest)
            const localVarPath = `/api/v0/itinerary/flight/denyScheduleChange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(denyScheduleChangeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch flight itineraries
         * @param {FlightItineraryRequest} flightItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ItineraryFlightPut: async (flightItineraryRequest: FlightItineraryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flightItineraryRequest' is not null or undefined
            assertParamExists('apiV0ItineraryFlightPut', 'flightItineraryRequest', flightItineraryRequest)
            const localVarPath = `/api/v0/itinerary/flight`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flightItineraryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch single flight itinerary
         * @param {SingleFlightItineraryRequest} singleFlightItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ItineraryFlightSinglePut: async (singleFlightItineraryRequest: SingleFlightItineraryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'singleFlightItineraryRequest' is not null or undefined
            assertParamExists('apiV0ItineraryFlightSinglePut', 'singleFlightItineraryRequest', singleFlightItineraryRequest)
            const localVarPath = `/api/v0/itinerary/flight/single`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(singleFlightItineraryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate passenger
         * @param {PassengersForFareRequest} passengersForFareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PassengerValidationPost: async (passengersForFareRequest: PassengersForFareRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passengersForFareRequest' is not null or undefined
            assertParamExists('apiV0PassengerValidationPost', 'passengersForFareRequest', passengersForFareRequest)
            const localVarPath = `/api/v0/passengerValidation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passengersForFareRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get trip price
         * @param {PassengersForFareRequest} passengersForFareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TripPricePost: async (passengersForFareRequest: PassengersForFareRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passengersForFareRequest' is not null or undefined
            assertParamExists('apiV0TripPricePost', 'passengersForFareRequest', passengersForFareRequest)
            const localVarPath = `/api/v0/tripPrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passengersForFareRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete passenger
         * @param {DeletePassengerRequest} deletePassengerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FlightPassengersDeletePost(deletePassengerRequest: DeletePassengerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FlightPassengersDeletePost(deletePassengerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0FlightPassengersDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get passenger
         * @param {GetPassengerRequest} getPassengerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FlightPassengersGetPut(getPassengerRequest: GetPassengerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaybePersonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FlightPassengersGetPut(getPassengerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0FlightPassengersGetPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all passengers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FlightPassengersListPut(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FlightPassengersListPut(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0FlightPassengersListPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update passenger
         * @param {UpdatePassengerRequest} updatePassengerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FlightPassengersUpdatePut(updatePassengerRequest: UpdatePassengerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FlightPassengersUpdatePut(updatePassengerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0FlightPassengersUpdatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accept schedule change
         * @param {AcceptScheduleChangeRequest} acceptScheduleChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ItineraryFlightAcceptScheduleChangePost(acceptScheduleChangeRequest: AcceptScheduleChangeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AcceptScheduleChangeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ItineraryFlightAcceptScheduleChangePost(acceptScheduleChangeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0ItineraryFlightAcceptScheduleChangePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deny schedule change
         * @param {DenyScheduleChangeRequest} denyScheduleChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ItineraryFlightDenyScheduleChangePost(denyScheduleChangeRequest: DenyScheduleChangeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DenyScheduleChangeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ItineraryFlightDenyScheduleChangePost(denyScheduleChangeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0ItineraryFlightDenyScheduleChangePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch flight itineraries
         * @param {FlightItineraryRequest} flightItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ItineraryFlightPut(flightItineraryRequest: FlightItineraryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlightItineraryResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ItineraryFlightPut(flightItineraryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0ItineraryFlightPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch single flight itinerary
         * @param {SingleFlightItineraryRequest} singleFlightItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ItineraryFlightSinglePut(singleFlightItineraryRequest: SingleFlightItineraryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleFlightItineraryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ItineraryFlightSinglePut(singleFlightItineraryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0ItineraryFlightSinglePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate passenger
         * @param {PassengersForFareRequest} passengersForFareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PassengerValidationPost(passengersForFareRequest: PassengersForFareRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PassengersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PassengerValidationPost(passengersForFareRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0PassengerValidationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get trip price
         * @param {PassengersForFareRequest} passengersForFareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0TripPricePost(passengersForFareRequest: PassengersForFareRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripPricingSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0TripPricePost(passengersForFareRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0TripPricePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Delete passenger
         * @param {DeletePassengerRequest} deletePassengerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FlightPassengersDeletePost(deletePassengerRequest: DeletePassengerRequest, options?: RawAxiosRequestConfig): AxiosPromise<AnyResponse> {
            return localVarFp.apiV0FlightPassengersDeletePost(deletePassengerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get passenger
         * @param {GetPassengerRequest} getPassengerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FlightPassengersGetPut(getPassengerRequest: GetPassengerRequest, options?: RawAxiosRequestConfig): AxiosPromise<MaybePersonResponse> {
            return localVarFp.apiV0FlightPassengersGetPut(getPassengerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List all passengers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FlightPassengersListPut(options?: RawAxiosRequestConfig): AxiosPromise<PersonListResponse> {
            return localVarFp.apiV0FlightPassengersListPut(options).then((request) => request(axios, basePath));
        },
        /**
         * Update passenger
         * @param {UpdatePassengerRequest} updatePassengerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FlightPassengersUpdatePut(updatePassengerRequest: UpdatePassengerRequest, options?: RawAxiosRequestConfig): AxiosPromise<AnyResponse> {
            return localVarFp.apiV0FlightPassengersUpdatePut(updatePassengerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Accept schedule change
         * @param {AcceptScheduleChangeRequest} acceptScheduleChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ItineraryFlightAcceptScheduleChangePost(acceptScheduleChangeRequest: AcceptScheduleChangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AcceptScheduleChangeResponse> {
            return localVarFp.apiV0ItineraryFlightAcceptScheduleChangePost(acceptScheduleChangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deny schedule change
         * @param {DenyScheduleChangeRequest} denyScheduleChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ItineraryFlightDenyScheduleChangePost(denyScheduleChangeRequest: DenyScheduleChangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<DenyScheduleChangeResponse> {
            return localVarFp.apiV0ItineraryFlightDenyScheduleChangePost(denyScheduleChangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch flight itineraries
         * @param {FlightItineraryRequest} flightItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ItineraryFlightPut(flightItineraryRequest: FlightItineraryRequest, options?: RawAxiosRequestConfig): AxiosPromise<FlightItineraryResponseResponse> {
            return localVarFp.apiV0ItineraryFlightPut(flightItineraryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch single flight itinerary
         * @param {SingleFlightItineraryRequest} singleFlightItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ItineraryFlightSinglePut(singleFlightItineraryRequest: SingleFlightItineraryRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleFlightItineraryResponse> {
            return localVarFp.apiV0ItineraryFlightSinglePut(singleFlightItineraryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate passenger
         * @param {PassengersForFareRequest} passengersForFareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PassengerValidationPost(passengersForFareRequest: PassengersForFareRequest, options?: RawAxiosRequestConfig): AxiosPromise<PassengersResponse> {
            return localVarFp.apiV0PassengerValidationPost(passengersForFareRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get trip price
         * @param {PassengersForFareRequest} passengersForFareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TripPricePost(passengersForFareRequest: PassengersForFareRequest, options?: RawAxiosRequestConfig): AxiosPromise<TripPricingSummaryResponse> {
            return localVarFp.apiV0TripPricePost(passengersForFareRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Delete passenger
     * @param {DeletePassengerRequest} deletePassengerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0FlightPassengersDeletePost(deletePassengerRequest: DeletePassengerRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0FlightPassengersDeletePost(deletePassengerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get passenger
     * @param {GetPassengerRequest} getPassengerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0FlightPassengersGetPut(getPassengerRequest: GetPassengerRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0FlightPassengersGetPut(getPassengerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all passengers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0FlightPassengersListPut(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0FlightPassengersListPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update passenger
     * @param {UpdatePassengerRequest} updatePassengerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0FlightPassengersUpdatePut(updatePassengerRequest: UpdatePassengerRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0FlightPassengersUpdatePut(updatePassengerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accept schedule change
     * @param {AcceptScheduleChangeRequest} acceptScheduleChangeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0ItineraryFlightAcceptScheduleChangePost(acceptScheduleChangeRequest: AcceptScheduleChangeRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0ItineraryFlightAcceptScheduleChangePost(acceptScheduleChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deny schedule change
     * @param {DenyScheduleChangeRequest} denyScheduleChangeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0ItineraryFlightDenyScheduleChangePost(denyScheduleChangeRequest: DenyScheduleChangeRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0ItineraryFlightDenyScheduleChangePost(denyScheduleChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch flight itineraries
     * @param {FlightItineraryRequest} flightItineraryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0ItineraryFlightPut(flightItineraryRequest: FlightItineraryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0ItineraryFlightPut(flightItineraryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch single flight itinerary
     * @param {SingleFlightItineraryRequest} singleFlightItineraryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0ItineraryFlightSinglePut(singleFlightItineraryRequest: SingleFlightItineraryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0ItineraryFlightSinglePut(singleFlightItineraryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate passenger
     * @param {PassengersForFareRequest} passengersForFareRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PassengerValidationPost(passengersForFareRequest: PassengersForFareRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PassengerValidationPost(passengersForFareRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get trip price
     * @param {PassengersForFareRequest} passengersForFareRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0TripPricePost(passengersForFareRequest: PassengersForFareRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0TripPricePost(passengersForFareRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



